import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { Container } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import {
  onGetQAForBB,
  onGetQAForFixedline,
  onGetAreaCode,
  onGetNLE,
  onSaveAscertain,
} from '../../../components/eir-ascertain-service/ascertain.util';
import EirAscertainServiceContainer from '../../../components/eir-ascertain-service/EirAscertainServiceContainer';
import NavBar from '../../../components/eir-nav-bar/NavBar';
import getStrapiData from '../../../integration/strapi';
import EirHeader from '../../../components/eir-header/EirHeader';

export async function getServerSideProps() {
  let cmsHeaderData = {};
  const cmsData = await getStrapiData('ascertain');
  cmsHeaderData = await getStrapiData('header');
  return {
    props: { cmsData: cmsData?.data, cmsHeaderData },
  };
}

const AscertainService = ({ cmsData, cmsHeaderData }) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const router = useRouter();
  const { publicRuntimeConfig } = getConfig();

  const [state, setState] = useState({
    bbUANValidated: false,
    hasMultipleUANServices: false,
    fixedLineValidated: false,
    NLEData: null,
    AscertainData: null,
  });
  const [errorOnValidate, setErrorOnValidate] = useState({
    bbUANError: '',
    errorOnValidate: '',
    NLEError: '',
    SaveAscertainError: '',
  });
  const [showLoader, setShowLoader] = useState(false);

  const getQAForBB = async bbUAN => {
    setShowLoader(true);
    const { result, errors } = await onGetQAForBB({ graphql, bbUAN });
    if (errors) {
      setErrorOnValidate({
        ...state,
        bbUANError: errors,
      });
      setShowLoader(false);
      return { result, errors };
    }
    setState({
      ...state,
      accountNumber: result?.getQAForBroadband?.accountNumber,
      bbUANValidated: !!result,
      hasMultipleUANServices: result?.getQAForBroadband?.activeServices.length > 0,
    });
    setShowLoader(false);
    return { result, errors };
  };
  const getQAForFixedline = async (uan, fixedLineNumber) => {
    const { result, errors } = await onGetQAForFixedline({ graphql, uan, fixedLineNumber });
    if (errors) {
      setErrorOnValidate({
        ...state,
        fixedLineError: errors,
      });
      return { result, errors };
    }
    setState({
      ...state,
      fixedLineUAN: result?.getQAForFixedline?.accountNumber,
      fixedLinePhoneNumber: result?.getQAForFixedline?.phoneNumber,
      fixedLineValidated: !!result,
    });
    return { result, errors };
  };
  const getAreaCode = async () => {
    const { result } = await onGetAreaCode({ graphql });
    setState({
      ...state,
      areaCodes: result.areaCodes,
    });
  };
  const getNLE = async () => {
    const { result, errors } = await onGetNLE({ graphql });
    if (errors) {
      setErrorOnValidate({
        ...state,
        NLEError: errors,
      });
      return { result: null, errors };
    }
    setState({
      ...state,
      NLEData: result.getNLE,
    });
    return { result: result?.getNLE, errors };
  };
  const saveAscertain = async (offerId, ascertainRequest) => {
    const { result, errors } = await onSaveAscertain({
      graphql,
      offerId,
      ascertainRequest,
    });
    if (errors) {
      setErrorOnValidate({
        ...state,
        SaveAscertainError: errors,
      });
      return;
    }
    setState({
      ...state,
      AscertainData: result,
    });
    return result;
  };
  const backStep = async () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband`);
  };

  return (
    <>
      <EirHeader cmsHeaderData={cmsHeaderData?.data} />
      <main id='main' tabIndex={-1}>
        <NavBar
          forwardArrowIcon={
            <ArrowForward sx={{ m: 0, color: theme.palette.secondary.contrastText }} />
          }
          backArrowIcon={<ArrowBack sx={{ m: 0, color: theme.palette.secondary.contrastText }} />}
          backButtonText='Back'
          forwardButtonText='Skip'
          backButtonOnClick={() => {
            backStep();
          }}
          nextButtonOnClick={() => {}}
          disableBack={false}
          disableNext
        />
        <Container
          maxWidth='100%'
          sx={{
            backgroundSize: '100%',
            backgroundColor: theme.palette.primary.backgroundColor,
            minHeight: '100vh',
          }}
        >
          <EirAscertainServiceContainer
            cmsData={cmsData}
            getQAForBB={getQAForBB}
            getQAForFixedline={getQAForFixedline}
            getAreaCode={getAreaCode}
            getNLE={getNLE}
            saveAscertain={saveAscertain}
            areacodes={state.areaCodes}
            NLEData={state.NLEData}
            AscertainData={state.AscertainData}
            bbUANError={errorOnValidate.bbUANError}
            fixedLineError={errorOnValidate.fixedLineError}
            bbUANValidated={state.bbUANValidated}
            accountNumber={state.accountNumber}
            fixedLineUAN={state.fixedLineUAN}
            fixedLinePhoneNumber={state.fixedLinePhoneNumber}
            hasMultipleUANServices={state.hasMultipleUANServices}
            fixedLineValidated={state.fixedLineValidated}
            showLoader={showLoader}
          />
        </Container>
      </main>
    </>
  );
};

export default AscertainService;
